import React from 'react';

import Animated, { FlipInEasyY } from 'react-native-reanimated';

import { ProductCardOptions } from 'components/product-card-options';

import {
  PRODUCT_CARD_PADDING,
  PRODUCT_CARD_WIDTH,
  ProductCardContainer,
  ProductCardOptionsContainer,
  ProductCardReverseContainer,
} from './styled';
import { IProductCardReverse } from './types';

export const ProductCardReverse: React.FC<IProductCardReverse> = ({
  isSelected,
  height,
  options,
  selection,
  onOptionPress,
}) => {
  return (
    <ProductCardReverseContainer width={PRODUCT_CARD_WIDTH} padding={PRODUCT_CARD_PADDING} flex={1}>
      <Animated.View entering={FlipInEasyY} style={{ flex: 1 }}>
        <ProductCardContainer $isFlipped $isSelected={isSelected} minHeight={height} flex={1}>
          <ProductCardOptionsContainer>
            <ProductCardOptions
              options={options ?? []}
              selectedValue={selection.toString()}
              onChange={onOptionPress}
            />
          </ProductCardOptionsContainer>
        </ProductCardContainer>
      </Animated.View>
    </ProductCardReverseContainer>
  );
};
